import { skipToken } from '@reduxjs/toolkit/query/react';
import { useGetCompetitorsQuery } from '../api/trackerEndpointsApi';
import type { CompetitorInsight } from '../types';

const NO_COMPETITORS: CompetitorInsight[] = [];

/**
 * Tracked competitors of the project. Callers share one cached request;
 * competitor create/update/delete mutations invalidate it.
 */
export function useProjectCompetitors(projectId: string | null) {
  const { data } = useGetCompetitorsQuery(projectId ?? skipToken);
  return projectId ? (data ?? NO_COMPETITORS) : NO_COMPETITORS;
}
